let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kHyPI")).then(() => parcelRequire('3S6Pq'));